import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container container--small" }
const _hoisted_2 = { class: "highlights__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "highlights__title" }, "Highlights, notes and bookmarks", -1)
const _hoisted_4 = { class: "container highlights__container" }
const _hoisted_5 = {
  key: 0,
  class: "highlights__btn-box"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Show all highlights", -1)

import { computed } from 'vue'

import HighlightsList from '@/app/components/doc/highlights/HighlightsList.vue'
import ExportHighlightsButton from '@/app/components/book/highlights/ExportHighlightsButton.vue'

import { DocView } from '@/models/doc'


export default /*#__PURE__*/_defineComponent({
  __name: 'Highlights',
  props: {
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  doc: DocView
};



const hasHighlights = computed(() => {
  return props.doc.highlights.length > 0
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["highlights details-content", _unref(hasHighlights) || 'highlights--empty'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(ExportHighlightsButton, { class: "highlights__button" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(HighlightsList, {
          doc: __props.doc,
          limit: 2,
          hideButtonOnMobile: true
        }, null, 8, ["doc"]),
        (_unref(hasHighlights))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: {
              name: __props.doc.routeNames().highlights,
              params: { url_slug: __props.doc.url_slug },
            },
                class: "highlights__button highlights__view-all btn-outline-primary btns--white book-unit__btn btns btns--small btns--full"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})